import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Landing route for office.mavistech.uk's "Helpdesk" sidebar tab, which
// embeds this app in an iframe pointed at /sso?code=... instead of the
// normal /login form. Redeems the one-time code (minted by mavis_backend
// the moment the admin clicked the tab) for a real session here, then
// hands off to the normal board view -- same destination a password login
// would land on.
const SsoLogin = () => {
  const [searchParams] = useSearchParams();
  const [error, setError] = useState('');
  const { ssoLogin } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const code = searchParams.get('code');
    if (!code) {
      setError('Missing sign-in code.');
      return;
    }

    let cancelled = false;
    (async () => {
      try {
        await ssoLogin(code);
        if (!cancelled) navigate('/board/SD', { replace: true });
      } catch (err) {
        if (cancelled) return;
        const message = err.response?.data?.error || 'Sign-in failed. Please open Helpdesk again from the office console.';
        setError(message);
      }
    })();

    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="login-screen">
      <div className="login-card">
        <h1>Mavis Service Desk</h1>
        {error ? (
          <div className="login-error">{error}</div>
        ) : (
          <p className="subtitle">Signing you in...</p>
        )}
      </div>
    </div>
  );
};

export default SsoLogin;
